import {kngApi, utilityApi} from 'yxt-biz-pc/packages/api';
// 获取课程类型
export const getKngType = kngId => kngApi.get(`/knowledge/typeInfo/${kngId}`);

export const getAuditKngInfo = kngId => kngApi.get(`/knowledge/audit/kng/detail/${kngId}`);
export const getAttributeConfig = kngId => kngApi.get(`/attribute/kng/info?kngId=${kngId}&type=1`);
export const getTags = kngId => utilityApi.get(`/tagtargets/${kngId}/orgtags`);
export const getBossDownConfig = orgId => kngApi.get(`/download/config?orgId=${orgId}`);
export const getBossConfig = bodyParams => kngApi.post('kv/conf/query/switch', bodyParams);
export const getCheatInfo = () => kngApi.get('kngConf/cheat');
export const getVisitorInfo = kngId => kngApi.get(`visitor/kng/config/${kngId}`);
export const getMultipleConf = () => kngApi.get('kv/multiple/conf');
export const getCatalogAllPath = (id) => kngApi.get(`knowledge/getcatalogallpath?cataLogId=${id}`);
